export default {
  MORPHOLOGY_TYPE_A: 'MORPHOLOGY_TYPE_A',
  MORPHOLOGY_TYPE_B: 'MORPHOLOGY_TYPE_B',
  MORPHOLOGY_TYPE_C: 'MORPHOLOGY_TYPE_C'
}
